import React from "react";
import PropTypes from "prop-types";
import ChecklistItem from "./ChecklistItem";
import { withTranslation } from "react-i18next";

const ChecklistItems = (
    {
        items,
        addItem,
        removeItem,
        handleOnChange,
        handleReorder,
        checkbox = false,
        readOnly,
        t
    }) => {

    const onDragStart = (event, index) => {
        if (readOnly) {
            return;
        }
        event.dataTransfer.setData("text/plain", String(index));
        event.dataTransfer.effectAllowed = "move";
    };

    const onDragOver = (event) => {
        if (readOnly) {
            return;
        }
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
    };

    const onDrop = (event, index) => {
        if (readOnly) {
            return;
        }
        event.preventDefault();
        const fromIndexRaw = event.dataTransfer.getData("text/plain");
        const fromIndex = Number(fromIndexRaw);
        if (Number.isNaN(fromIndex) || fromIndex === index) {
            return;
        }
        if (handleReorder) {
            handleReorder(fromIndex, index);
        }
    };

    return items && items.map((item, index) =>
        <ChecklistItem
            index={index}
            key={`checklistItem${index}`}
            add={items.length === index + 1}
            addItem={addItem}
            checkbox={checkbox}
            dataTestId={`checklistItem${index}`}
            handleOnChange={handleOnChange}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDrop={onDrop}
            item={item}
            removeItem={removeItem}
            readOnly={readOnly}
        />);
};

ChecklistItems.defaultProps = {
    items: []
};

ChecklistItems.propTypes = {
    addItem: PropTypes.func,
    checkbox: PropTypes.bool,
    handleOnChange: PropTypes.func,
    handleReorder: PropTypes.func,
    items: PropTypes.array.isRequired,
    removeItem: PropTypes.func,
    readOnly: PropTypes.bool,
    t: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool
};

export default withTranslation()(ChecklistItems);
